<template>
<div class="home-container">
  <div class="hx-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>供应系统</el-breadcrumb-item>
      <el-breadcrumb-item>运营管理</el-breadcrumb-item>
      <el-breadcrumb-item>优惠活动</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <div class="hx-form-container box-shadow">
    <el-form :model="listParams" label-width="100px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="活动名称：">
            <el-input size="small" v-model="listParams.name" style="width: 100%;"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="活动状态：">
            <el-select size="small" v-model="listParams.status" style="width: 100%;">
              <el-option :value="1" label="未使用"></el-option>
              <el-option :value="2" label="使用中"></el-option>
              <el-option :value="3" label="已过期"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item>
            <el-button size="small" type="primary" @click="loadTableData">
              查询
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">

    <div slot="action"></div>

    <hx-table-result-col>
      <div class="wrap-table-info-display">
        <el-button class="align-left" type="primary" size="small" @click="toCreate">
          新增
        </el-button>
        <el-button class="align-left" size="small" @click="batchOperation" :disabled="releaseArr.length === 0">
          批量发布
        </el-button>
        <span class="table-info-display">
          <span>总条数：</span>
        <span class="alert-text ft16">{{ pager.total }}</span>
        </span>
      </div>
    </hx-table-result-col>

    <el-table slot="content" :data="tableData" max-height="800" border @selection-change="handleSelectionChange" @selection-all="handleSelectionChange">
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>

      <el-table-column align="center" width="60" label="序号">
        <template slot-scope="scope">
          <span
              v-text="(pager.pageIndex > 1 ?
               (pager.pageIndex-1) * pager.pageSize :
               0) + scope.$index + 1">
            </span>
        </template>
      </el-table-column>

      <el-table-column prop="name" align="center" label="活动名称">
      </el-table-column>

      <el-table-column prop="type" align="center" label="活动类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type">{{ scope.row.type === 1 ? '折扣' : '现金减免' }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="status" align="center" label="活动状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status">
            <span v-show="scope.row.status === 1" style="color : grey">未使用</span>
          <span v-show="scope.row.status === 2" style="color : orange">生效</span>
          <span v-show="scope.row.status === 3" style="color : red">已过期</span>
          </span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="$router.push({ name : 'promotionDetail', query : {id : scope.row.id}})">编辑</el-button>
          <confirm-button type="text" style="margin: 0 10px;" title="确认要发布该条数据？" @confirmed="releasePromotion([scope.row.id])">
            <span>发布</span>
          </confirm-button>
          <confirm-button type="text" style="margin: 0 10px;" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
            <span>删除</span>
          </confirm-button>
        </template>
      </el-table-column>
    </el-table>
  </hx-table-result>
</div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      listParams: {
        name: "",
        status: ""
      },
      releaseArr: [],
      tableData: [],
      tableLoading: false,
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      }
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载table列表
     */
    loadTableData() {
      const bodyParams = Object.assign({}, this.listParams, {
        pageIndex: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      });
      Vue.ajaxGet(this, global.apiUrl + "/good/promotion/list", bodyParams, true).then(
        res => {
          if (res.list) {
            this.tableData = res.list;
            this.pager.total = res.total;
          }
        }
      );
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * checkbox的change事件
     * @param selection
     */
    handleSelectionChange(selection) {
      this.releaseArr = [];
      selection.map((item) => {
        this.releaseArr.push(item.id);
      });
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.$router.push({
        name: "promotionDetail"
      });
    },
    /**
     * 批量操作
     */
    batchOperation () {
      if (this.releaseArr.length > 0) {
        this.releasePromotion(this.releaseArr);
      }
    },
    /**
     * 发布优惠
     * @param arr
     */
    releasePromotion (arr) {
      Vue.ajaxPost(this, global.apiUrl + '/good/promotion/publish', { publishIds: arr }).then((res) => {
        this.$message.success(res.info);
        this.loadTableData();
      });
    },
    /**
     * 删除数据条目
     * @param id
     */
    deleteItem(id) {
      Vue.ajaxDel(this, global.apiUrl + "/good/promotion/delete", {
        id: id
      }).then(res => {
        this.$message.success(res.info);
        this.loadTableData();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
